import { useApplicationContext } from '../utils/applicationContext';
import { useSelector } from 'react-redux';
import { selectLocationId } from '../selectors/locations';
import { useMemo } from 'react';
import { IOpenVillageBannerSettings } from '../types/banners';

export const useOpenVillageFilterAvailable = (): boolean => {
  const { config } = useApplicationContext();
  const locationId = useSelector(selectLocationId);

  return useMemo(() => {
    const bannerEnabled = config.get<IOpenVillageBannerSettings>('countryside.openVillage.filterEnabled');
    const regionIds = config.get<number[]>('countryside.openVillage.regionIds');
    const companyIds = config.get<number[]>('countryside.openVillage.companyIds');

    return Boolean(bannerEnabled && companyIds?.length && locationId && regionIds?.includes(locationId));
  }, [locationId, config]);
};
